var React = require('react');

function DoneGreen (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("g",{"id":"Icon/40/step-success","transform":"translate(-13.000000, -14.000000)","stroke":"#3BD391","strokeWidth":"3"},React.createElement("polyline",{"id":"Rectangle-Copy","transform":"translate(20.146447, 18.353553) rotate(-315.000000) translate(-20.146447, -18.353553) ","points":"22.4381133 12.8535534 22.386211 23.8340966 17.8547799 23.8535534"}))));
}

DoneGreen.defaultProps = {"width":"30px","height":"12px","viewBox":"0 0 15 14","version":"1.1"};

module.exports = DoneGreen;

DoneGreen.default = DoneGreen;
